import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccountContext from '../../services/AccountContext';
import memberService from '../../services/memberApi';

import styles from './Credits.module.less';

function Credits({ refreshCredits, gap, linkWidth }) {
  //TODO Old code has an AB test for this.

  const { ready, memberId, isPremium, isSchoolAdmin } = useContext(
    AccountContext
  );
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    if (!memberId) {
      setCredits(null);
    } else if (ready && !isPremium) {
      memberService.getMemberCredits(memberId).then(response => {
        // Check if the response is not null and has a valid Count property
        if (response && response.Count != null) {
          setCredits(response.Count);
        } else {
          setCredits(null);
        }
      });
    }
  }, [ready, refreshCredits, memberId]);
  // Do not display the "remaining limit" message until we get a valid remaining credits number
  if (credits === null) return null;

  const linkText = credits === 0 ? 'Upgrade now' : 'Get unlimited access';
  const resourceLink = (
    <a href={isSchoolAdmin ? '/my/school-admin/settings/?' : '/pricing/'}>
      {linkText}
    </a>
  );

  const fontWeight =
    credits === 0 ? { fontWeight: 'bold' } : { fontWeight: 'normal' };
  const size = {
    gap: gap,
  };
  const linkPadding =
    credits === 0 && linkWidth !== undefined
      ? { paddingTop: 10 }
      : { paddingTop: 5 };
  const messagePadding =
    credits === 0 && linkWidth === undefined
      ? { paddingLeft: 26 }
      : { paddingLeft: 16 };

  const contents =
    isPremium || memberId === undefined ? null : (
      <div className={styles.creditContainer} style={{ ...size }}>
        <span
          className={styles.creditMessage}
          style={{ ...fontWeight, ...messagePadding }}
        >
          You have {credits === 0 ? 'no' : credits} free download
          {credits === 1 ? null : 's'} remaining this month.
        </span>
        <div
          className={styles.creditLink}
          style={{ ...linkPadding, width: linkWidth }}
        >
          {resourceLink}
        </div>
      </div>
    );

  return contents;
}

Credits.propTypes = {
  refreshCredits: PropTypes.bool.isRequired,
};

export default Credits;
